import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Check = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <circle cx="12.8" cy="12.8" r="12.8" transform="translate(2.667 2.667)" fill="none" />
      <path
        d="M12.8 0a12.8 12.8 0 1 0 12.8 12.8A12.8 12.8 0 0 0 12.8 0zm-2.133 18.575L4.892 12.8 6.4 11.292l4.267 4.267L19.2 7.025l1.508 1.508z"
        transform="translate(2.667 2.667)"
      />
    </svg>
  );
};

Check.displayName = 'Check';
